import Platform from '@/types/Platform'

export default Platform.fromStorable({
	id: 'shopify',
	settings: {
		logo: require('@/assets/logo-shopify.png'),
		name: 'Shopify',
		format: {
			width: 2500,
			height: 2500
		},
		maxCount: 20,
		defaultOverlays: [{ name: 'WatermarkAnnotation', args: [true] }],
		setRules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					}
				}
			]
		},
		rules: [
			[
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					}
				}
			],
			[
				{
					category: ['special', 'measurements'],
					allowFullPicture: true,
					padding: {
						top: 0.24,
						bottom: 0.31
					},
					overlays: [
						{ name: 'BrandLogoAnnotation' },
						{ name: 'MeasurementAnnotation', args: [true] }
					]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['special', 'materialDetail'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['special', 'colors'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			[
				{
					category: ['special', 'logo'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			]
		],
		fillRule: [
			{
				category: ['alternate', null],
				allowFullPicture: true,
				padding: {
					top: 0.2,
					bottom: 0.2
				},
				overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
			}
		]
	}
})
